module.exports = __webpack_public_path__ + "static/media/for-you-menu-icon.cdd0e61e.svg";